import Vue from 'vue';

const EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
  $eventbus: {
    get() {
      return EventBus;
    }
  }
});

export default EventBus;
